import { testimonials } from "@/mocks/categories";

export default function TestimonialsSection() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-10 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-wider text-accent-600 mb-3">
            <i className="ri-star-line text-sm"></i>
            Testimonials
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            Trusted by Shoppers
          </h2>
          <p className="mt-2 text-sm text-foreground-600">
            Real feedback from people who use Pandabuy Sheet every day
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
          {testimonials.map((t) => (
            <div
              key={t.name}
              className="bg-background-50 rounded-lg p-5 md:p-6 border border-background-200/70"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0">
                  <img
                    src={t.avatarUrl}
                    alt={t.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div>
                  <p className="text-sm font-semibold text-foreground-950">{t.name}</p>
                  <p className="text-xs text-foreground-500">{t.role}</p>
                </div>
              </div>
              <div className="relative">
                <i className="ri-double-quotes-l text-accent-200 text-2xl absolute -top-2 -left-1"></i>
                <p className="text-sm text-foreground-700 leading-relaxed pl-5">
                  {t.text}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}